import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LeadsWorkspaceV2 from './LeadsWorkspaceV2';
import LeadBulkActionsDrawer from './LeadBulkActionsDrawer';
import CrmImportPanel from './CrmImportPanel';

export default function LeadsWorkspaceShell() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const crm = params.get('crm');
  const shellOwnsCrmModal = crm === 'salesforce' || crm === 'dynamics';

  const closeCrm = () => {
    const next = new URLSearchParams(location.search);
    next.delete('crm');
    next.delete('salesforce');
    next.delete('dynamics');
    next.delete('reason');
    navigate({ pathname: location.pathname, search: next.toString() ? `?${next.toString()}` : '' }, { replace: true });
  };

  return <>
    <LeadsWorkspaceV2 />
    <LeadBulkActionsDrawer onChanged={() => window.location.reload()} />
    {shellOwnsCrmModal && <CrmImportPanel onClose={closeCrm} onImported={() => window.location.assign('/leads')} />}
  </>;
}
